import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { AuthModalV2 } from "./v2/auth-modal-v2";
export const AuthModal = ({ isOpen , handleClose , useBrowserNavigation , vehicleImage  })=>/*#__PURE__*/ _jsx(_Fragment, {
        children: isOpen && /*#__PURE__*/ _jsx(AuthModalV2, {
            handleClose: handleClose,
            vehicleImage: vehicleImage,
            useBrowserNavigation: !!useBrowserNavigation
        })
    });
